import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classNames from 'classnames';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';

import styles from './style.scss';


const BookRentHeader = ({ book }) => {
  const authorName = get(book, 'authors[0].cover_name', '');
  const bookName = get(book, 'name', '');
  const bookImageUrl = get(book, 'default_cover');
  const isAudioBook = get(book, 'type', '') === 'audio';

  return (
    <div className={styles.bookRentHeader}>
      <div className={styles.headerBackgroundContainer}>
        <CroppedImage
          width={600}
          height={120}
          className={styles.headerBackgroundContainerImage}
          src={bookImageUrl}
          alt={bookName} />
      </div>
      <CroppedImage
        className={classNames(styles.bookCover, isAudioBook && styles.bookCoverAudioBook)}
        width={isAudioBook ? 60 : 112}
        height={isAudioBook ? 60 : 180}
        src={bookImageUrl}
        alt={bookName} />
      <div className={styles.bookTitle}>
        <h1 className={styles.bookName}>{bookName}</h1>
        <h3 className={styles.authorName}>{authorName}</h3>
      </div>
    </div>
  );
};

BookRentHeader.propTypes = {
  book: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    default_cover: PropTypes.string.isRequired,
    authors: PropTypes.array.isRequired,
  }),
};

export default BookRentHeader;
